import { DateTime } from 'luxon'

import { City } from '@/model/City'
import { Snapshot } from '@/model/Snapshot'
import { TimeStepValueFactory } from './TimeStepValueFactory'
import { TimeStepMaxFactory } from './TimeStepMaxFactory'
import { TimeStepValue } from '@/model/TimeStepValue'
import { SnapshotValueDTO } from '@/api/core/dto/snapshot/SnapshotValueDTO'

export class SnapshotValueFactory {
  static createEmpty(city: City, timestamp: DateTime): Snapshot<TimeStepValue> {
    const result = new Snapshot<TimeStepValue>(city, timestamp)
    result.setReference(TimeStepValueFactory.createEmpty(result, timestamp))
    return result
  }

  static fromDTO(dto: SnapshotValueDTO, city: City): Snapshot<TimeStepValue> {
    const result = new Snapshot<TimeStepValue>(city, DateTime.fromISO(dto.timestamp, { zone: 'UTC' }))

    for (const timeStepDTO of dto.history) {
      result.addHistory(TimeStepValueFactory.fromDTO(timeStepDTO, result))
    }

    result.setReference(TimeStepValueFactory.fromDTO(dto.reference, result))

    for (const timeStepDTO of dto.forecasts) {
      result.addForecast(TimeStepValueFactory.fromDTO(timeStepDTO, result))
    }

    result.setMax(TimeStepMaxFactory.fromDTO(dto.maxFrame, result))

    return result
  }
}
